module.exports = __webpack_public_path__ + "static/media/LogoCircleWhite.12178fe9.jpg";